//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const curalate = angular.module('curalate');

    //
    // Desktop implementation of EnvironmentService.
    //
  curalate.service('EnvironmentService', function() {
    this.getTemplateRootDirectory = function() {
            // On mobile, we just use the root-root directory for now. We'll
            // refactor this later after we're unified on pinsights-js-shared.
      return '/partials/';
    };
  });
})();
